import { WithBots } from '../../shared/types'

import { Action } from './types'
import { SET_WITHBOTS } from './constants'

export const setWithBots = (payload: WithBots): Action => ({
  type: SET_WITHBOTS,
  payload,
})
